import { Component, Input, Output, EventEmitter, OnInit, TemplateRef } from '@angular/core';
import { TreeNode } from 'primeng/api';

@Component({
  selector: 'app-tree-generic-one',
  templateUrl: './tree-generic-one.component.html',
  styleUrl: './tree-generic-one.component.scss'
})
export class TreeGenericOneComponent implements OnInit {
  @Input() treeData: any[] = [];
  @Input() selectedNode: TreeNode | null = null;
  @Input() expandedKeys: { [key: string]: boolean } = {};
  @Input() keysAddButton: string[] = [];
  @Input() emptyMessage: string = 'No se encontró información.';

  // Templates personalizados para diferentes secciones
  @Input() addNodeLevel0Template: TemplateRef<any> | null = null;
  @Input() addNodeLevel1Template: TemplateRef<any> | null = null;
  @Input() addNodeLevel2Template: TemplateRef<any> | null = null;
  @Input() nodeContentTemplate: TemplateRef<any> | null = null;
  @Input() nodeActionsTemplate: TemplateRef<any> | null = null;

  @Output() nodeExpand = new EventEmitter<any>();
  @Output() nodeCollapse = new EventEmitter<any>();
  @Output() selectionChange = new EventEmitter<any>();

  ngOnInit(): void {
    // Inicialización si es necesaria
  }

  isAddNode(node: any): boolean {
    return this.keysAddButton.includes(node.key);
  }

  getAddNodeLevel(node: any): number {
    if (node.key === 'add-programa') return 0;
    if (node.key === 'add-bien-servicio') return 1;
    if (node.key === 'add-indicador') return 2;
    return -1;
  }

  handleNodeExpand(event: any): void {
    this.nodeExpand.emit(event);
  }

  handleNodeCollapse(event: any): void {
    this.nodeCollapse.emit(event);
  }

  handleSelectionChange(): void {
    this.selectionChange.emit(this.selectedNode);
  }
}
